/**
 * Created on 2025-06-16
 */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'

const styles = theme => ({
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: '26px 0 26px 0',
  },
  confirmModalHeader: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#2E2E32',
    lineHeight: '18px',
    padding: '0 24px',
    marginBottom: '16px',
  },
  confirmModalContent: {
    fontSize: '20px',
    color: '#616581',
    marginTop: '24px',
    padding: '0 24px',
    lineHeight: '24px',
    marginBottom: '0px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
    padding: '0 24px',
    gap: '10px',
    borderTop: '1px solid #E0E0E0',
    paddingTop: '25px',
  },
  createButton: {
    padding: '8px 12px',
    border: 0,
    background: 'var(--color-button-primary)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-white)',
    fontSize: '16px',
    fontWeight: '500',
    width: '147px',
  },
  cancelButton: {
    padding: '8px 12px',
    border: '1px solid var(--color-button-primary)',
    background: 'var(--color-white)',
    borderRadius: 10,
    cursor: 'pointer',
    color: 'var(--color-button-primary)',
    fontSize: '16px',
    fontWeight: '500',
    width: '147px',
  },
})

const TwoFactorConfirmModal = ({ classes, isEnabling, onConfirm, onCancel }) => {
  const title = isEnabling ? 'Enable two factor authentication' : 'Disable two factor authentication'
  const message = isEnabling
    ? 'Are you sure you want to enable two factor authentication?'
    : 'Are you sure you want to disable two factor authentication?'

  return (
    <div className={classes.modalContainer}>
      <h2 className={classes.confirmModalHeader}>{title}</h2>
      <p className={classes.confirmModalContent}>{message}</p>
      <div className={classes.buttonContainer}>
        <button className={classes.cancelButton} onClick={onCancel}>
          No
        </button>
        <button className={classes.createButton} onClick={onConfirm}>
          Yes
        </button>
      </div>
    </div>
  )
}

TwoFactorConfirmModal.propTypes = {
  classes: PropTypes.object.isRequired,
  isEnabling: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default withStyles(styles, { withTheme: true })(TwoFactorConfirmModal)
